export default __webpack_public_path__ + "static/weel-homepage-animation-fallback-b1d99fc4376d06aebfe59d2816dc6fc8.png";